import { render, staticRenderFns } from "./CustomListSendStep.vue?vue&type=template&id=9fe633e6"
import script from "./CustomListSendStep.vue?vue&type=script&lang=js"
export * from "./CustomListSendStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports